import { render, staticRenderFns } from "./PosterCard.vue?vue&type=template&id=34dfe95b"
import script from "./PosterCard.vue?vue&type=script&lang=ts"
export * from "./PosterCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports